import { createFileRoute, type SearchSchemaInput } from '@tanstack/react-router';
import { findCreatorsStartersQuery } from '@/services/find-creators';
import { engineCampaignsQuery, engineInfoQuery, engineSearchesQuery } from '@/services/search-engine';
import { roleIncludes } from '@/features/team/role-gate';
import { FindCreatorsPage, type FindCreatorsSearch } from '@/features/find-creators/find-creators-page';

export const Route = createFileRoute('/_authed/find-creators')({
  // `search` is the search open on the page (a positive whole id), so Back and Forward walk in and out of it.
  validateSearch: (search: { search?: unknown } & SearchSchemaInput): FindCreatorsSearch => {
    const id = typeof search.search === 'number' ? search.search : typeof search.search === 'string' ? Number(search.search) : Number.NaN;
    return Number.isInteger(id) && id > 0 ? { search: id } : {};
  },
  // Her role decides the page; her role first: a role without it requests nothing and sees the role card.
  loader: async ({ context: { queryClient, team } }) => {
    if (!team || !(await roleIncludes(queryClient, team, 'find-creators'))) return;
    await Promise.all([
      queryClient.ensureQueryData(engineSearchesQuery(team.id)).catch(() => null),
      queryClient.prefetchQuery(engineInfoQuery(team.id)),
      queryClient.prefetchQuery(engineCampaignsQuery(team.id)),
      queryClient.prefetchQuery(findCreatorsStartersQuery(team.id)),
    ]);
  },
  component: FindCreatorsRoute,
});

function FindCreatorsRoute() {
  return <FindCreatorsPage search={Route.useSearch()} />;
}
